import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    peso: [],
  },

  getters: {
    getPeso: (state) => state.peso,
  },

  mutations: {
    SET_PESO(state, peso) {
      state.peso = peso;
    },
  },

  actions: {
    async fetchPeso({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catPeso')
        .then((response) => {
          commit('SET_PESO', response.data.data);
        });
    },
  },
};
